import { axiosInstance } from "../axiosConfig.ts";
import {
  ISbpTransferBank,
  IMakeSbpTransferResponse,
  IGetSbpTransferTermsResponse,
  ICheckActiveSbpTransferResponse,
  IGetSbpTransferScheduleResponse,
  IMakeSbpTransferPollingResponse,
} from "./types.ts";

export const spbTransferAPI = {
  makeTransfer: async ({
    amount,
    bankId,
    trancheProductCode,
  }: {
    amount: string;
    bankId: string;
    trancheProductCode: string;
  }): Promise<IMakeSbpTransferResponse> => {
    const response = await axiosInstance.post<IMakeSbpTransferResponse>(
      "/v1/tranches/cash-transfer",
      {
        amount,
        bankId,
        trancheProductCode,
      },
    );

    return response.data;
  },

  makeTransferPolling: async (id: string): Promise<IMakeSbpTransferPollingResponse> => {
    const response
        = await axiosInstance.get<IMakeSbpTransferPollingResponse>(`/v1/tranches/${id}/result`);

    return response.data;
  },

  checkActiveTransfer: async (): Promise<ICheckActiveSbpTransferResponse> => {
    const response = await axiosInstance.get<ICheckActiveSbpTransferResponse>(
      "/v1/tranches/active/info",
    );

    return response.data;
  },

  getAvailableTerms: async (): Promise<IGetSbpTransferTermsResponse> => {
    const response = await axiosInstance.get<IGetSbpTransferTermsResponse>(
      "/v1/tranches/info",
    );

    return response.data;
  },

  getSchedule: async ({
    amount,
    fasCode,
    signal,
  }: {
    amount: string;
    fasCode: string;
    signal?: AbortSignal;
  }): Promise<IGetSbpTransferScheduleResponse> => {
    const response = await axiosInstance.post<IGetSbpTransferScheduleResponse>(
      "/v1/offers", {
        amount,
        products: [{ code: fasCode }],
      },
      { signal },
    );

    return response.data;
  },

  getBanks: async (): Promise<ISbpTransferBank[]> => {
    const response = await axiosInstance.get<ISbpTransferBank[]>(
      "/v1/sbp-banks",
    );

    return response.data;
  },
};
